// @ts-nocheck - untyped
import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import SpeedIcon from '@mui/icons-material/Speed';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssessmentIcon from '@mui/icons-material/Assessment';

import './ServicesMonitor.scss';

function getSummaryFromSeries(series = []) {
  const out = {
    totalRequests: null,
    avgLatency: null,
    minLatency: null,
    maxLatency: null,
    latestBucket: null,
    dataPointCount: 0,
  };
  series.forEach(s => {
    const values = (s.values || []).map(v => Number(v)).filter(n => !Number.isNaN(n));
    if (values.length > 0) out.dataPointCount = Math.max(out.dataPointCount, values.length);
    const name = (s.metricName || '').toLowerCase();
    if (values.length === 0) return;
    if (name === 'rate' || name.includes('count')) {
      if (out.totalRequests == null) out.totalRequests = values.reduce((a, b) => a + b, 0);
      if (out.latestBucket == null) out.latestBucket = values[values.length - 1];
    }
    if (name === 'latency' || name.includes('avg') || name.includes('percentile')) {
      if (out.avgLatency == null)
        out.avgLatency = values.reduce((a, b) => a + b, 0) / values.length;
      if (out.minLatency == null) out.minLatency = Math.min(...values);
      if (out.maxLatency == null) out.maxLatency = Math.max(...values);
    }
  });
  return out;
}

function formatNumber(n) {
  if (n == null || Number.isNaN(n)) return '-';
  if (n >= 1e6) return (n / 1e6).toFixed(1) + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(1) + 'k';
  return Number.isInteger(n) ? n.toString() : n.toFixed(2);
}

export default function SummaryCards({ series = [] }) {
  const s = getSummaryFromSeries(series);

  const cards = [
    {
      label: 'Total requests',
      value: s.totalRequests != null ? formatNumber(s.totalRequests) : '-',
      unit: '',
      icon: <RequestQuoteIcon className="sm-summary-icon" fontSize="small" />,
    },
    {
      label: 'Avg latency',
      value: s.avgLatency != null ? s.avgLatency.toFixed(0) : '-',
      unit: 'ms',
      icon: <SpeedIcon className="sm-summary-icon" fontSize="small" />,
    },
    {
      label: 'Latency range',
      value:
        s.minLatency != null && s.maxLatency != null
          ? `${s.minLatency.toFixed(0)} - ${s.maxLatency.toFixed(0)}`
          : '-',
      unit: 'ms',
      icon: <SpeedIcon className="sm-summary-icon" fontSize="small" />,
    },
    {
      label: 'Latest bucket',
      value: s.latestBucket != null ? formatNumber(s.latestBucket) : '-',
      unit: 'requests',
      icon: <TrendingUpIcon className="sm-summary-icon" fontSize="small" />,
    },
    {
      label: 'Data points',
      value: s.dataPointCount > 0 ? s.dataPointCount.toLocaleString() : '-',
      unit: '',
      icon: <AssessmentIcon className="sm-summary-icon" fontSize="small" />,
    },
  ].filter(c => c.value !== '-');

  if (cards.length === 0) return null;

  return (
    <Box className="sm-summary-root">
      {cards.map((card, idx) => (
        <Paper key={idx} className="sm-summary-card" elevation={0}>
          {card.icon}
          <Typography className="sm-summary-label">{card.label.toUpperCase()}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' }}>
            <Typography className="sm-summary-value">{card.value}</Typography>
            {card.unit && (
              <Typography component="span" className="sm-summary-unit">
                {card.unit}
              </Typography>
            )}
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
